import styled from 'styled-components'
import { useModuleContext } from '../contexts/EventsContext'
import EventCardList from './EventCardList'
import { Row, Col, Spinner } from '@mch-group/uikit-components'

/**
 *
 * @returns List of Events, including overlay/spinner during filter re-validation
 */

const EventsList = () => {
  //@ts-ignore
  const [{ events, isLoadingEvents }] = useModuleContext()
  if (!events) {
    return null
  }

  return (
    <>
      <StyledRow className={isLoadingEvents ? 'overlay' : 'mb-10'}>
        {isLoadingEvents && <Spinner variant='button' theme='secondary' />}
        {events.map((event) => (
          <Col xs={12} lg={3}
            key={`${event.id}${event.openingDateTimes.length ? `-${event.openingDateTimes[0].id}` : ''}`}
            className='d-flex'
          >
            {/* Event card list */ /* @ts-ignore */}
            <EventCardList withAddToCollection item={event} />
          </Col>
        ))}
      </StyledRow>
    </>
  )
}

const StyledRow = styled(Row)`
  &.overlay {
    position: relative;
  }

  &.overlay::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.5);
    z-index: 1;
  }
`


export default EventsList
